import type { ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import ClaimBaggageDisruptionPage from '@/pages/claim-baggage-disruption.page';

export const Route = createFileRoute(
  '/_authenticated/contracts/$contractId/claim-baggage-disruption'
)({
  component: RouteComponent,
});

function RouteComponent(): ReactElement {
  const { contractId } = Route.useParams();

  return <ClaimBaggageDisruptionPage contractId={contractId} />;
}
